const App = () => (
	<div id="app">
		<p>Hello world!</p>
	</div>
)

export default App;
